import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.42 12.9861V14.9344C17.42 16.8777 15.839 18.4587 13.8957 18.4587H5.43739C3.49409 18.4587 1.91309 16.8777 1.91309 14.9344V5.0663C1.91309 3.123 3.49409 1.54199 5.43739 1.54199H12.486C15.2081 1.54199 17.42 3.32233 17.42 5.62533V9.01085V12.2531C17.42 12.6253 17.42 12.7683 17.42 12.9861ZM5.43739 17.0489H11.7811V2.95171H5.43739C4.27155 2.95171 3.32281 3.90046 3.32281 5.0663V14.9344C3.32281 16.1002 4.27155 17.0489 5.43739 17.0489ZM16.0103 12.9861V10.0228C16.0103 9.61656 16.0103 7.83863 16.0103 7.62082V5.62533C16.0103 3.61635 14.0415 2.95171 13.1909 2.95171V17.0489H13.8957C15.0616 17.0489 16.0103 16.1002 16.0103 14.9344V12.9861Z"
      fill="#00503B"
    />
    <path
      d="M8.43685 9.83608L8.77441 9.44915L9.76865 8.53706C10.0693 8.26146 10.0693 7.81528 9.76865 7.54039C9.61871 7.40294 9.42186 7.33386 9.22501 7.33386C9.02816 7.33386 8.83131 7.40294 8.68137 7.54039L7.44107 8.67803C5.91081 10.057 6.49414 10.6403 7.44107 11.6293L8.68137 12.7669C8.98202 13.0425 9.46799 13.0425 9.76865 12.7669C10.0693 12.492 10.0693 12.0459 9.76865 11.7703L8.77441 10.7167L8.42779 10.2854C8.32153 10.1532 8.32535 9.96388 8.43685 9.83608Z"
      fill="#00503B"
    />
  </svg>
);

const MenuClosingIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default MenuClosingIcon;
